import { apiClient } from './client';

export async function getNotifications(limit = 20) {
  return (await apiClient.get('/auth/notifications', { params: { limit } })).data;
}

export async function markNotificationRead(id) {
  return (await apiClient.post(`/auth/notifications/${id}/read`)).data;
}

export async function markAllNotificationsRead() {
  return (await apiClient.post('/auth/notifications/read-all')).data;
}
